import {
  Download,
  VideoCamera,
  FilmStrip,
  Scissors,
  Brain,
  Sparkle,
  Lightning,
  Play,
} from '@phosphor-icons/react';
import { Flex, Space } from 'antd';
import { useNavigate } from 'react-router';

const Workflow = () => {
  
  const navigate = useNavigate();

  const _Digit = () => {
    const digits = ['0', '1'];

    return Array.from({ length: 50 }).map((item, index) => {
      const left = Math.random() * 100;
      const delay = Math.random() * 10;
      const size = 0.8 + Math.random() * 1.2;
      return (
        <div
          className="carousel-binary-digit"
          key={index}
          style={{
            left: `${left}%`,
            animationDelay: `${delay}s`,
            fontSize: `${size}rem`,
          }}
        >
          {digits[Math.floor(Math.random() * digits.length)]}
        </div>
      );
    });
  };

  const _FloatingIcon = () => {
    const icons = [<VideoCamera weight="fill" />, <Play weight="fill" />, <Sparkle weight="fill" />, <Lightning weight="fill" />];
    return Array.from({ length: 8 }).map((item, index) => {
      const top = 10 + Math.random() * 80;
      const left = 10 + Math.random() * 80;
      const delay = Math.random() * 5;
      const size = 20 + Math.random() * 30;
      return (
        <div
          className="carousel-floating-icon"
          key={index}
          style={{
            top: `${top}%`,
            left: `${left}%`,
            animationDelay: `${delay}s`,
            fontSize: `${size}px`,
          }}
        >
          {icons[index % icons.length]}
        </div>
      );
    });
  };

  const _GlowOrb = () => {
    return Array.from({ length: 6 }).map((item, index) => {
      const top = 10 + Math.random() * 80;
      const left = 10 + Math.random() * 80;
      const delay = Math.random() * 3;
      const size = 30 + Math.random() * 50;
      const colors = ['#ff0080', '#00ffff', '#ff9800', '#4caf50', '#9c27b0', '#2196f3'];
      return (
        <div
          className="carousel-glow-orb"
          key={index}
          style={{
            top: `${top}%`,
            left: `${left}%`,
            animationDelay: `${delay}s`,
            width: `${size}px`,
            height: `${size}px`,
            background: `radial-gradient(circle, ${colors[index % colors.length]} 0%, transparent 70%)`,
          }}
        ></div>
      );
    });
  };

  const _WaveLine = () => {
    return Array.from({ length: 5 }).map((item, index) => (
      <div
        className="carousel-wave-line"
        key={index}
        style={{
          animationDelay: `${index * 0.5}s`,
          opacity: 1 - index * 0.15,
        }}
      ></div>
    ));
  };

  return (
    <div className="carousel-slide carousel-three-slide">
      <div className="carousel-three-decorations">
        <div className="carousel-three-hexagon"></div>
        <div className="carousel-three-hexagon"></div>
        <div className="carousel-three-hexagon"></div>
        <div className="carousel-three-circuit"></div>
        <div className="carousel-three-particles">
          <div className="carousel-three-particle carousel-three-particle-1"></div>
          <div className="carousel-three-particle carousel-three-particle-2"></div>
          <div className="carousel-three-particle carousel-three-particle-3"></div>
          <div className="carousel-three-particle carousel-three-particle-4"></div>
          <div className="carousel-three-particle carousel-three-particle-5"></div>
          <div className="carousel-three-particle carousel-three-particle-6"></div>
          <div className="carousel-three-particle carousel-three-particle-7"></div>
          <div className="carousel-three-particle carousel-three-particle-8"></div>
          <div className="carousel-three-particle carousel-three-particle-9"></div>
          <div className="carousel-three-particle carousel-three-particle-10"></div>
        </div>
        <div className="carousel-three-gradient-overlay"></div>
        <_FloatingIcon />
        <_GlowOrb />
        <div className="carousel-wave-container">
          <_WaveLine />
        </div>
      </div>
      <Flex className="container carousel-content-wrapper" align="center">
          <div className="flex-1 carousel-content carousel-three-content">
            <div className="carousel-three-badge">
              <div className="carousel-three-badge-pulse"></div>
              <span>AI驱动·全场景视频生产力</span>
            </div>
            <h1 className="carousel-title">
              <span className="carousel-three-title-main">剪映</span>
              <span className="carousel-three-title-highlight">小助手</span>
            </h1>
            <div className="carousel-three-points">
              <div className="carousel-three-point">
                <span className="carousel-three-point-icon">
                  <Brain weight="fill" />
                </span>
                <div className="carousel-feature-content">
                  <h4 className="carousel-feature-title">智能自动化</h4>
                  <p className="carousel-feature-desc">开源剪映小助手，将剪映手动操作自动化</p>
                </div>
              </div>
              <div className="carousel-three-point">
                <span className="carousel-three-point-icon">
                  <VideoCamera weight="fill" />
                </span>
                <div className="carousel-feature-content">
                  <h4 className="carousel-feature-title">智能视频生成</h4>
                  <p className="carousel-feature-desc">图转视频/图生视频（AI生成动态内容）</p>
                </div>
              </div>
              <div className="carousel-three-point">
                <span className="carousel-three-point-icon">
                  <Scissors weight="fill" />
                </span>
                <div className="carousel-feature-content">
                  <h4 className="carousel-feature-title">专业剪辑</h4>
                  <p className="carousel-feature-desc">视频拼接·裁剪·字幕特效</p>
                </div>
              </div>
              <div className="carousel-three-point">
                <span className="carousel-three-point-icon">
                  <FilmStrip weight="fill" />
                </span>
                <div className="carousel-feature-content">
                  <h4 className="carousel-feature-title">专业编辑</h4>
                  <p className="carousel-feature-desc">多轨配音与音频处理</p>
                </div>
              </div>
            </div>
            <Space className="carousel-three-buttons" size="large">
              <Space className="carousel-three-btn btn btn-primary" onClick={() => navigate('/download', { replace: true })}>
                <Download className="carousel-btn-icon" weight="fill" size={20} />
                立即下载
              </Space>
            </Space>
          </div>
        <div className="flex-1 relative carousel-right">
          <div className="carousel-three-visual">
            <div className="carousel-three-glow carousel-three-glow-1"></div>
            <div className="carousel-three-glow carousel-three-glow-2"></div>

            <div className="carousel-three-connections">
              <div className="carousel-three-connection-line"></div>
              <div className="carousel-three-connection-line"></div>
              <div className="carousel-three-connection-line"></div>
            </div>
          </div>
          <div className="carousel-shield-container">
            <div className="carousel-shield">
              <div className="carousel-binary-code">
                <_Digit />
              </div>
              <div className="carousel-shield-inner">
                <div className="carousel-shield-icon">
                  <VideoCamera weight="fill" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Flex>
    </div>
  );
};

export default Workflow;
